import React from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

// Redux
import { useDispatch } from "react-redux";
import { addSupplier as onAddNewSupplier } from "../../slices/thunks";
//formik
import { useFormik } from "formik";
import * as Yup from "yup";

const AddSupplier = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      sup_name: "",
      sup_company: "",
      sup_email: "",
      sup_city: "",
      sup_address: "",
      sup_country: "",
      sup_mov: 0,
      sup_slug: "",
      sup_phone: "",
      sup_contact: "",
      sup_state: "",
      sup_website: "",
      sup_notes: "",
      sup_listFrequencyDays: 0,
    },
    validationSchema: Yup.object({
      sup_name: Yup.string().required("Please Enter a Supplier Name"),
      sup_company: Yup.string(),
      sup_email: Yup.string()
        .required("Please Enter a Supplier Email")
        .email("Please Enter a Valid Email"),
      sup_city: Yup.string(),
      sup_address: Yup.string(),
      sup_country: Yup.string(),
      sup_state: Yup.string(),
      sup_mov: Yup.number(),
      sup_slug: Yup.string(),
      sup_phone: Yup.string(),
      sup_website: Yup.string(),
      sup_notes: Yup.string(),
      sup_listFrequencyDays: Yup.number(),
    }),
    onSubmit: (values) => {
      const newSupplier = {
        sup_name: values.sup_name,
        sup_company: values.sup_company,
        sup_email: values.sup_email,
        sup_city: values.sup_city,
        sup_address: values.sup_address,
        sup_country: values.sup_country,
        sup_slug: values.sup_slug,
        sup_mov: values.sup_mov,
        sup_phone: values.sup_phone,
        sup_contact: values.sup_contact,
        sup_state: values.sup_state,
        sup_website: values.sup_website,
        sup_notes: values.sup_notes,
        sup_listFrequencyDays: values.sup_listFrequencyDays,
      };
      dispatch(onAddNewSupplier(newSupplier));
      validation.resetForm();
      onClose();
    },
  });
  return (
    <Modal
      Modal
      isOpen={open}
      toggle={onClose}
      modalClassName="zoomIn"
      centered
      tabIndex="-1"
    >
      <ModalHeader toggle={onClose} className="p-3 bg-primary-subtle">
        <Row className="align-items-center gy-3">
          <div className="col-sm">
            <h5 className="card-title mb-0">Add new supplier</h5>
          </div>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Card>
                <CardBody>
                  <Row>
                    <Col sm={12}>
                      <div className="mb-3">
                        <Label className="form-label">Name</Label>
                        <Input
                          name="sup_name"
                          type="text"
                          className={
                            validation.touched.sup_name &&
                            validation.errors.sup_name
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_name || ""}
                        />
                        {validation.touched.sup_name &&
                        validation.errors.sup_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Vendor ID</Label>
                        <Input
                          name="sup_slug"
                          type="text"
                          className={
                            validation.touched.sup_slug &&
                            validation.errors.sup_slug
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_slug || ""}
                        />
                        {validation.touched.sup_slug &&
                        validation.errors.sup_slug ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_slug}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="sup_email"
                          type="email"
                          className={
                            validation.touched.sup_email &&
                            validation.errors.sup_email
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_email || ""}
                        />
                        {validation.touched.sup_email &&
                        validation.errors.sup_email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Phone</Label>
                        <Input
                          name="sup_phone"
                          type="text"
                          className={
                            validation.touched.sup_phone &&
                            validation.errors.sup_phone
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_phone || ""}
                        />
                        {validation.touched.sup_phone &&
                        validation.errors.sup_phone ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_phone}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Contact</Label>
                        <Input
                          name="sup_contact"
                          type="text"
                          className={
                            validation.touched.sup_contact &&
                            validation.errors.sup_contact
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_contact || ""}
                        />
                        {validation.touched.sup_contact &&
                        validation.errors.sup_contact ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_contact}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Company</Label>
                        <Input
                          name="sup_company"
                          type="text"
                          className={
                            validation.touched.sup_company &&
                            validation.errors.sup_company
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_company || ""}
                        />
                        {validation.touched.sup_company &&
                        validation.errors.sup_company ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_company}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Address</Label>
                        <Input
                          name="sup_address"
                          type="text"
                          className={
                            validation.touched.sup_address &&
                            validation.errors.sup_address
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_address || ""}
                        />
                        {validation.touched.sup_address &&
                        validation.errors.sup_address ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_address}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">City</Label>
                        <Input
                          name="sup_city"
                          type="text"
                          className={
                            validation.touched.sup_city &&
                            validation.errors.sup_city
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_city || ""}
                        />
                        {validation.touched.sup_city &&
                        validation.errors.sup_city ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_city}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">State</Label>
                        <Input
                          name="sup_state"
                          type="text"
                          className={
                            validation.touched.sup_state &&
                            validation.errors.sup_state
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_state || ""}
                        />
                        {validation.touched.sup_state &&
                        validation.errors.sup_state ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_state}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Country</Label>
                        <Input
                          name="sup_country"
                          type="text"
                          className={
                            validation.touched.sup_country &&
                            validation.errors.sup_country
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_country || ""}
                        />
                        {validation.touched.sup_country &&
                        validation.errors.sup_country ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_country}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Website</Label>
                        <Input
                          name="sup_website"
                          type="url"
                          className={
                            validation.touched.sup_website &&
                            validation.errors.sup_website
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_website || ""}
                        />
                        {validation.touched.sup_website &&
                        validation.errors.sup_website ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_website}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">MOV</Label>
                        <Input
                          name="sup_mov"
                          type="number"
                          className={
                            validation.touched.sup_mov &&
                            validation.errors.sup_mov
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_mov}
                        />
                        {validation.touched.sup_mov &&
                        validation.errors.sup_mov ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_mov}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">
                          List Frequency Days
                        </Label>
                        <Input
                          name="sup_listFrequencyDays"
                          type="number"
                          className={
                            validation.touched.sup_listFrequencyDays &&
                            validation.errors.sup_listFrequencyDays
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_listFrequencyDays}
                        />
                        {validation.touched.sup_listFrequencyDays &&
                        validation.errors.sup_listFrequencyDays ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_listFrequencyDays}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Notes</Label>
                        <Input
                          name="sup_notes"
                          type="textarea"
                          className={
                            validation.touched.sup_notes &&
                            validation.errors.sup_notes
                              ? "is-invalid"
                              : ""
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sup_notes || ""}
                        />
                        {validation.touched.sup_notes &&
                        validation.errors.sup_notes ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sup_notes}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <div className="text-end">
                        <button
                          onClick={onClose}
                          type="button"
                          className="btn btn-danger waves-effect waves-light me-1"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success waves-effect waves-light "
                        >
                          Create Supplier
                        </button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Form>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default AddSupplier;
